import "./addCriteriaModal.scss";
import {Box, Menu, MenuItem, Modal, Select, Typography} from "@mui/material";
import {useContext, useState} from "react";
import {CRITERIA_QUESTION_PRIORITY} from "../../../../../../constants";
import {ReactComponent as PlusIcon} from "../../../../../../assets/icons/Plus.svg";
import {IsDarkThemeOnContext} from "../../../../../../App";


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30vw',
    boxShadow: 24
};

const AddCriteriaModal = ({show, closeModal, onCreateCriteria}) => {
    const [criteriaName, setCriteriaName] = useState("")
    const [criteriaDescription, setCriteriaDescription] = useState("")
    const [checklist, setChecklist] = useState([{question: '', priority: ''}])
    const [errorMessage, setErrorMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const isDarkThemeOn = useContext(IsDarkThemeOnContext);

    const handleCriteriaNameChange = (e) => {
        const text = e.target.value;
        setCriteriaName(text);
    }

    const handleCriteriaDescriptionChange = (e) => {
        const text = e.target.value;
        setCriteriaDescription(text);
    }

    const handleQuestionChange = (e, index) => {
        const text = e.target.value;
        const updatesChecklist = [...checklist];
        updatesChecklist[index].question = text;
        setChecklist(updatesChecklist);
    }

    const handlePriorityChange = (e, index) => {
        const text = e.target.value;
        const updatesChecklist = [...checklist];
        updatesChecklist[index].priority = text;
        setChecklist(updatesChecklist);
    }
    const addNewChecklist = () => {
        const newChecklist = {question: '', priority: ''}
        setChecklist(checklist => ([...checklist, newChecklist]));
    }

    const userAddedChecklist = checklist.filter(({question, priority}) => !!question && !!priority);
    const disableCreateChecklist = !criteriaName || !criteriaDescription || userAddedChecklist.length === 0;

    const handleAddCriteria = async () => {
        try {
            console.log('Adding criteria...');
            setIsLoading(true)
    
            const payload = {
                name: criteriaName,
                description: criteriaDescription,
                checklist: userAddedChecklist
            };
    
            console.log('Payload:', payload);
    
            const response = await onCreateCriteria(payload);
            console.log('Response from onCreateCriteria:', response);
            setIsLoading(false)
    
            if (response && response.id) {
                console.log('Criteria added successfully');
                handleOnClose();
            } else {
                console.log('Failed to add criteria. Invalid response:', response);
                setErrorMessage(JSON.stringify(response));
            }
        } catch (error) {
            setIsLoading(false)
            console.log('An error occurred while adding criteria:', error);
            setErrorMessage(error && error.message)
        }
    };

    const handleOnClose = () => {
        setCriteriaName('');
        setCriteriaDescription('');
        setChecklist([{ question: '', priority: '' }]);
        setErrorMessage('')
        closeModal()
    }

    return <Modal
        open={show}
        onClose={handleOnClose}
        className={"add-criteria-modal"}
        id={`${isDarkThemeOn ? 'dark-theme' : 'light-theme'}`}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <div>
            <Box sx={style} className={"modal-content"}>
                <p className={"title"}>Create Custom Criteria</p>
                {errorMessage && <div className="error-message">{`${errorMessage}`}</div>}
                <div className={"modal-body"}>
                    <div className={"name-description"}>
                        <div className={"input-field"}>
                            <label className={"required"}>Name</label>
                            <input type="text" placeholder="Criteria Name"
                                   className={"input-box"}
                                   value={criteriaName}
                                   required onChange={handleCriteriaNameChange}/>
                        </div>
                        <div className={"input-field"}>
                            <label className={"required"}>Description</label>
                            <input type="text" placeholder="Description"
                                   className={"input-box"}
                                   value={criteriaDescription}
                                   required onChange={handleCriteriaDescriptionChange}/>
                        </div>
                    </div>
                    <p className={"checklist-field-title required"}>Checklist Questions</p>
                    <div className={"checklist"}>
                        {
                            checklist.map(({question, priority}, index) => {
                                return (<div className={"checklist-item"} key={index.toString()} style={{ marginBottom: '12px' }}>
                                    <div className={"question"}>
                                        {index === 0 && <label>Question</label>}
                                        <input type="text" placeholder="Question"
                                            className={"input-box"}
                                            value={question} onChange={e => handleQuestionChange(e, index)}/>
                                    </div>
                                    <div className={"priority"}>
                                        {index === 0 && <label>Priority</label>}
                                        <Select id="priority-select"
                                                MenuProps={{ classes: { paper: isDarkThemeOn ? 'dark-theme-dropdown' : '' } }}
                                                value={priority}
                                            onChange={e => handlePriorityChange(e, index)} classes={{root: "priority-select-dropdown", }}>
                                            <MenuItem sx={{ fontFamily: "Work Sans, Helvetica, Verdana, sans-serif", fontSize: "14px", justifyContent: 'center'}}
                                                value={CRITERIA_QUESTION_PRIORITY.HIGH.key}>{CRITERIA_QUESTION_PRIORITY.HIGH.name}</MenuItem>
                                            <MenuItem sx={{ fontFamily: "Work Sans, Helvetica, Verdana, sans-serif", fontSize: "14px", justifyContent: 'center' }}
                                                value={CRITERIA_QUESTION_PRIORITY.MEDIUM.key}>{CRITERIA_QUESTION_PRIORITY.MEDIUM.name}</MenuItem>
                                            <MenuItem sx={{ fontFamily: "Work Sans, Helvetica, Verdana, sans-serif", fontSize: "14px", justifyContent: 'center' }}
                                                value={CRITERIA_QUESTION_PRIORITY.LOW.key}>{CRITERIA_QUESTION_PRIORITY.LOW.name}</MenuItem>
                                        </Select>
                                    </div>
                                </div>)
                            }
                            )
                        }
                        <button className={"add-new-criteria-button"} onClick={addNewChecklist}>
                            <div className={"icon"}><PlusIcon/></div>
                            <p>Add New</p>
                        </button>
                    </div>
                </div>
                <div className={"modal-footer"}>
                    <button className={"blue-button create-criteria-button"} disabled={disableCreateChecklist || isLoading} onClick={handleAddCriteria}
                            title={disableCreateChecklist ? "Please add name, description and checklist to create criteria" : ""}>
                        {isLoading ? <div className="loading-spinner"></div> : 'Create Criteria'}
                    </button>
                </div>
            </Box>
        </div>
    </Modal>
}

export default AddCriteriaModal;